
import TbTourScenicApi from './src/TbTourScenic'
import TbTourCarApi from './src/TbTourCar'
import TbTourHomestayApi from './src/TbTourHomestay'
import TbTourHotelApi from './src/TbTourHotel'
import TbTourRestaurantApi from './src/TbTourRestaurant'
import TbTourEntertainmentApi from './src/TbTourEntertainment'
import TbTourTravelApi from './src/TbTourTravel'
import TbTourCompanyApi from './src/TbTourCompany'
import TbTourShoppingApi from './src/TbTourShopping'
import TbTourTravelCarApi from './src/TbTourTravelCar'
import TbTourSecurityApi from './src/TbTourSecurity'


let apis = {
   TbTourCompanyApi,
   TbTourScenicApi,
   TbTourCarApi,
   TbTourHomestayApi,
   TbTourHotelApi,
   TbTourRestaurantApi,
   TbTourEntertainmentApi,
   TbTourTravelApi,
   TbTourShoppingApi,
   TbTourTravelCarApi,
   TbTourSecurityApi
};

export default apis;
